import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { useCustomerView } from "@/hooks/use-customer-view";

export const Route = createFileRoute("/app/customer")({
  component: CustomerLayout,
});

function CustomerLayout() {
  const { profile, loading } = useAuth();
  const { active: viewingAsCustomer, setActive: setCustomerView } = useCustomerView();

  const isStaff = profile?.role === "staff" || profile?.role === "admin";

  useEffect(() => {
    // Staff who navigate into /app/customer/* implicitly enter customer view.
    if (!loading && profile && isStaff && !viewingAsCustomer) {
      setCustomerView(true);
    }
  }, [loading, profile, isStaff, viewingAsCustomer, setCustomerView]);

  if (loading || !profile) return null;

  return (
    <>
      <Outlet />
    </>
  );
}
